module.exports = __webpack_public_path__ + "img/send_b.686098c7.svg";